import { LocalStorage } from './storage';

const localStorage = new LocalStorage('crm-noMasking');
class NoMaskingManager {
  public getNoMasking() {
    const noMaskingString = localStorage.getItem('noMasking');
    if (!noMaskingString) return;
    const isNoMasking = JSON.parse(noMaskingString) as boolean;
    return isNoMasking;
  }

  public setNoMasking(isNoMasking: boolean) {
    localStorage.setItem('noMasking', JSON.stringify(isNoMasking));
  }

  public clearNoMasking() {
    localStorage.removeItem('noMasking');
  }
}

const noMaskingManager = new NoMaskingManager();
export { noMaskingManager };



// WEBPACK FOOTER //
// ./src/services/noMasking.ts